import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing/landing').then((m) => m.Landing),
  },
  {
    path: 'catalog',
    loadComponent: () => import('./features/catalog/catalog').then((m) => m.Catalog),
  },
  {
    path: 'product/:slug',
    loadComponent: () => import('./features/product-detail/product-detail').then((m) => m.ProductDetail),
  },
  {
    path: 'callback',
    loadComponent: () => import('./features/marketplace-callback/marketplace-callback').then(m => m.MarketplaceCallback),
  },
  {
    path: 'logout',
    loadComponent: () => import('./features/logout/logout').then(m => m.Logout),
  },
  {
    path: 'internalLogout',
    loadComponent: () => import('./features/logout/logout').then(m => m.Logout),
  },
  {
    path: 'partners',
    loadComponent: () => import('./features/partners/partners').then((m) => m.Partners),
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
  },
];
